<template>
  <div
    class="card-container"
    :class="{ 'card-active': active }"
    @click="selectBatch"
  >
    <p class="card-title">Lote {{ batch.lotId }}</p>
    <p class="card-status">
      {{ getStatusConvert(batch.currentStatus) }}
    </p>

    <div class="card-content">
      <img
        src="/static/images/caminhao-amostras.svg"
        alt="icone-caminhao-amostras"
      />
      <div>
        <p class="label">Total de amostras</p>
        <p class="value">
          {{ batch.totalSamples }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    batch: { type: Object, required: true },
    active: { type: Boolean, default: false },
  },
  methods: {
    selectBatch() {
      console.log('Batch selected:', this.batch)
      this.$emit('select-batch', this.batch)
    },
    getStatusConvert(status){
      if(status == "EM_TRANSITO")
        return "Em trânsito";
      
      if(status == "EM_TRANSITO_ENTRE_NTO")
        return "Em trânsito entre NTOs";

      return "Aguardando retirada";
    }
  },
}
</script>

<style scoped lang="scss">
.card-container {
  width: 290px;
  height: 142px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 1rem;
  cursor: pointer;

  &.card-active {
    border: 2px solid transparent;
    background-origin: border-box;
    background-clip: padding-box, border-box;
    background-image: linear-gradient(#fff, #fff),
      linear-gradient(90deg, #ec2072 0%, #7f1a54 100%);
  }

  &:hover {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  }

  .card-title {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #818181;
    margin: 0;
  }

  .card-status {
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    line-height: 20px;
    color: #fff;
    margin: 8px 0;
    background: #7f1a54;
    border-radius: 4px;
    padding: 2px 8px;
    width: fit-content;
  }

  .card-content {
    display: flex;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }

    p {
      margin: 0;

      &.value {
        font-weight: 700;
        font-size: 27.65px;
        line-height: 32px;
        color: #52cc9c;
      }

      &.label {
        font-size: 11.11px;
        color: #818181;
        font-weight: 600;
        text-transform: uppercase;
      }
    }
  }
}
</style>
